import React, { Component } from 'react'
import Axios from 'axios'
import './SpellCorrectionTruck.css'
import ProgressBar from '../ProgressBar/ProgressBar'
import Loader from '../Loader'
import { toast } from 'react-toastify'
import { Urls } from '../../Urls'
import { constants } from '../../constants'
import { logActivity } from '../Utilities'
// global variable for manual entries
var raw_manual = []
// global variable for drop down entries
var raw_suggestion = []
// global variable for input to be served against final API call
var raw_input = []
class SpellCorrectionTruck extends Component {
    constructor(props) {
        super(props)

        this.state = {
            select_status: 0,
            truck_types: [],
            search_list: [],
            loader: false
        }
    }

    componentDidMount() {
        // logActivity([
        //     {
        //         'screen': 'Spell Correction Truck',
        //         'module': 'Truck Asset Cleaning',
        //         'user_activity': 'page viewed',
        //         'user_activity': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Spell Correction"
        document.getElementById("header").style.opacity = "0.5"
        var body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "collection_name": "spell_sugg_trk",
            "key": "truck"
        }
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.dataset.fetch, body)
                .then(response => {
                    this.setState({
                        truck_types: response.data.data,
                        search_list: response.data.search,
                        loader: false
                    }, () => { if (this.state.truck_types.length === 0) { this.skip() } })
                    document.getElementById("header").style.opacity = "1"

                    var i;
                    for (i = 0; i < this.state.truck_types.length; i++) {
                        if (this.state.truck_types[i].Suggestion.length === 0) {
                            raw_suggestion[i] = {
                                "suggestion": this.state.truck_types[i].Truck
                            }
                        }
                        else {
                            raw_suggestion[i] = {
                                "suggestion": this.state.truck_types[i].Suggestion[0]
                            }
                        }
                        raw_manual[i] = {
                            "manual": ""
                        }
                    }
                    raw_input.push(raw_suggestion)
                    raw_input.push(raw_manual)
                })
                .catch(error => {
                    document.getElementById("header").style.opacity = "1"
                    this.setState({ loader: false })
                    toast.error("Error while processing your request")
                    console.log(error)
                })
        })
    }

    skip = () => {
        const body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "truck"
        }
        Axios.post(Urls.master, body)
            .then(response => {
                this.setState({
                    loader: false
                })
                document.getElementById("header").style.opacity = "1"
                sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                this.props.history.push({
                    pathname: "/FinalConsolidation"
                })
            })
            .catch(error => {
                this.setState({
                    loader: false
                })
                document.getElementById("header").style.opacity = "1"
                toast.error("Error while processing your request")
                console.log(error)
            })
    }

    selectChangeHandler = (event) => {
        this.setState({ select_status: 1 })

        if (event.target.value === "Other") {
            document.getElementById(event.target.name).disabled = false
            document.getElementById(event.target.name).required = true
            raw_suggestion[event.target.name - 1] = { "suggestion": "Other" }
            document.getElementById(event.target.name).style.border = "1px solid royalblue"
        }
        else {
            raw_manual[event.target.name - 1] = { "manual": "" }
            document.getElementById(event.target.name).disabled = true
            document.getElementById(event.target.name).required = false
            document.getElementById(event.target.name).style.border = "none"
        }
        raw_suggestion[event.target.name - 1] = {
            "suggestion": event.target.value
        }
    }

    manualChangeHandler = (event) => {
        raw_manual[event.target.id - 1] = {
            "manual": event.target.value
        }
    }

    submitHandler = (event) => {
        event.preventDefault()
        console.log(raw_suggestion)
        var emptyRows = []
        var i = 0
        for (i = 0; i < raw_manual.length; i++) {
            if (raw_suggestion[i]['suggestion'] === 'Other') {
                if (new RegExp(constants.regex_patterns.emptyString).test(raw_manual[i]['manual'])) {
                    emptyRows.push(raw_manual[i]['manual'])
                }
            }
        }
        if (emptyRows.length == 0) {
            // logActivity([
            //     {
            //         'screen': 'Spell Correction Truck',
            //         'module': 'Truck Asset Cleaning',
            //         'user_activity': 'data submission',
            //         'user_activity': new Date().toISOString()
            //     }
            // ])
            document.getElementById("header").style.opacity = "0.5"
            var body = {
                "dataset_id": localStorage.getItem("dataset_id"),
                "key": "truck",
                "input": raw_input,
                "collection_name": "spell_sugg_trk"
            }

            // API Call to dump
            this.setState({
                loader: true
            }, () => {
                Axios.post(Urls.dataset.dump, body)
                    .then(response => {
                        const body = {
                            "dataset_id": localStorage.getItem("dataset_id"),
                            "key": "truck"
                        }
                        Axios.post(Urls.master, body)
                            .then(response => {
                                this.setState({
                                    loader: false
                                })
                                document.getElementById("header").style.opacity = "1"
                                sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                                this.props.history.push({
                                    pathname: "/FinalConsolidation"
                                })
                            })
                            .catch(error => {
                                this.setState({
                                    loader: false
                                })
                                document.getElementById("header").style.opacity = "1"
                                toast.error("Error while processing your request")
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.setState({
                            loader: false
                        })
                        document.getElementById("header").style.opacity = "1"
                        toast.error("Error while processing your request")
                        console.log(error)
                    })
            })
        }
        else {
            alert('Please enter truck type')
        }
    }

    goBack = () => this.props.history.push({ pathname: "/directMatchTruck" })

    goToSummary = () => this.props.history.push({ pathname: "/summaryScreen" })

    render() {
        const search_data = this.state.search_list
        const truck_types = this.state.truck_types
        return (
            <div id="header">
                <div className={'tooltip-absolute'}>
                    <div className={'top-tooltip-container'}>
                        <div className={'top-tooltip-element'}>
                            <i style={{ fontSize: '20px' }} className={'fa fa-info-circle'}></i>
                        </div>
                        <div className={'top-tooltip-message'}>
                            Uncleaned Truck Types are highlighted in yellow color!
                        </div>
                    </div>
                </div>
                <Loader isLoading={this.state.loader} />
                <div className="container" style={{ "margin-bottom": "5%" }}>
                    <div>
                        <div className="row" align="center">
                            <div className="col-1">
                                <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table border="1" width="80%" id="dc_table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Raw Truck Type</th>
                                            <th>Suggestion</th>
                                            <th>User Input</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            truck_types.map((truck, i) =>
                                                (truck.Suggestion.length === 0) ? (
                                                    <tr style={{ "backgroundColor": "#f1fa3c" }}>
                                                        <td> {i + 1} </td>
                                                        <td> {truck.Truck} </td>
                                                        <td>
                                                            <select className="form-control" name={i + 1} onChange={this.selectChangeHandler}>
                                                                <option value={truck.Truck}> {truck.Truck} </option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input className="form-control" required list="autoComplete" onChange={this.manualChangeHandler} type="text" disabled placeholder="Enter Truck Type" id={i + 1} />
                                                            <datalist id="autoComplete">
                                                                {
                                                                    search_data.map(t => <option key={t} value={t}> {t} </option>)
                                                                }
                                                            </datalist>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                        <tr>
                                                            <td> {i + 1} </td>
                                                            <td> {truck.Truck} </td>
                                                            <td>
                                                                <select className="form-control" name={i + 1} onChange={this.selectChangeHandler}>
                                                                    {
                                                                        truck.Suggestion.map(s => <option value={s}> {s} </option>)
                                                                    }
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <input className="form-control" required list="autoComplete" onChange={this.manualChangeHandler} id={i + 1} type="text" disabled placeholder="Enter Truck Type" id={i + 1} />
                                                                <datalist id="autoComplete">
                                                                    {
                                                                        search_data.map(t => <option key={t} value={t}> {t} </option>)
                                                                    }
                                                                </datalist>
                                                            </td>
                                                        </tr>
                                                    )
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-1 navButtonsCircleRight">
                                <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="88%" />
                </div>
            </div>
        )
    }
}

export default SpellCorrectionTruck
